import { render } from "./left-menu.vue?vue&type=template&id=08b02b20&ts=true"
import script from "./left-menu.vue?vue&type=script&lang=ts"
export * from "./left-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__